import { Status, WithStatus } from '../models';

export const withStatus = (status: Status) => <TResponse extends {}>(response: TResponse) => {
  const result: WithStatus<TResponse> = {
    ...response,
    ...status
  };

  return result;
};